import { Component, OnInit, AfterViewInit, inject } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { ViewportScroller, CommonModule, AsyncPipe } from '@angular/common';
import { filter } from 'rxjs/operators';
import { NavbarComponent } from './shared/components/navbar/navbar.component';
import { SearchService } from './services/search.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, NavbarComponent, CommonModule, AsyncPipe],
  template: `
    <div class="top-progress" *ngIf="searchService.isSearching$ | async">
      <div class="top-progress__bar"></div>
    </div>
    <app-navbar></app-navbar>
    <main class="main-content" [class.has-header-margin]="!isHomePage">
      <router-outlet></router-outlet>
    </main>
  `,
  styles: [`
    .top-progress {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      height: 3px;
      z-index: 99999;
      overflow: hidden;
    }

    .top-progress__bar {
      height: 100%;
      background: linear-gradient(90deg, #3554d1, #7c3aed, #3554d1);
      background-size: 200% 100%;
      animation: progress-slide 1.5s ease-in-out infinite;
      border-radius: 0 2px 2px 0;
    }

    @keyframes progress-slide {
      0% {
        width: 0%;
        margin-left: 0;
      }
      50% {
        width: 70%;
        margin-left: 15%;
      }
      100% {
        width: 0%;
        margin-left: 100%;
      }
    }

    .main-content {
    }
    .main-content.has-header-margin {
      padding-top: 90px;
    }
    @media (max-width: 767px) {
      .main-content.has-header-margin {
        padding-top: 80px;
      }
    }
  `]
})
export class AppComponent implements OnInit, AfterViewInit {
  title = 'PusulaTatilClient';
  isHomePage = false;
  private readonly viewportScroller = inject(ViewportScroller);
  readonly searchService = inject(SearchService);

  constructor(private router: Router) {}

  ngOnInit() {
    // Arama sırasında scroll'u kilitle
    this.searchService.isSearching$.subscribe(isSearching => {
      document.body.style.overflow = isSearching ? 'hidden' : '';
    });

    // İlk sayfa yüklemesinde kontrol et
    this.checkIfHomePage();

    // Sayfa değiştiğinde JavaScript'in yeniden çalışmasını sağla
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      // Home sayfası kontrolü
      this.checkIfHomePage();
      
      // Sayfayı en üste scroll et
      this.viewportScroller.scrollToPosition([0, 0]);
      
      // DOM'un tamamen hazır olmasını bekle
      setTimeout(() => {
        this.initializeScripts();
        this.initAnimations();
      }, 200);
    });
  }
  
  private checkIfHomePage(): void {
    this.isHomePage = this.router.url === '/' || this.router.url === '';
  }

  ngAfterViewInit() {
    // Sayfa yüklendikten sonra JavaScript'i çalıştır
    this.initializeScripts();
  }

  private initializeScripts() {
    // Form elemanlarını başlat
    this.initFormElements();
    
    // Slider'ları başlat
    this.initSliders();
    
    // Diğer JavaScript fonksiyonlarını başlat
    this.initOthers();
  }

  private initFormElements() {
    // Form elemanlarını başlat
    const formElements = document.querySelectorAll('.js-form-dd');
    if (formElements.length > 0) {
      formElements.forEach(element => {
        element.addEventListener('click', (e) => {
          e.stopPropagation();
          element.classList.toggle('is-active');
        });
      });
    }
  }

  private initSliders() {
    // Slider'ları başlat
    const sliders = document.querySelectorAll('.js-slider');
    if (sliders.length > 0) {
      sliders.forEach(slider => {
        // Slider başlatma kodu
      });
    }
  }

  private initOthers() {
    // Diğer JavaScript fonksiyonlarını başlat
    // Örneğin: tabs, accordion, dropdown, vb.
  }

  private initAnimations() {
    // data-anim-wrap elementlerini bul ve animasyonları tetikle
    const animWrapElements = document.querySelectorAll('[data-anim-wrap]');
    animWrapElements.forEach((wrap: any) => {
      wrap.classList.add('animated');
      
      // İçindeki data-anim-child elementlerini de tetikle
      const children = wrap.querySelectorAll('[data-anim-child]');
      children.forEach((child: any, index: number) => {
        setTimeout(() => {
          child.classList.add('is-in-view');
        }, index * 100);
      });
    });

    // data-anim elementlerini tetikle
    const animElements = document.querySelectorAll('[data-anim]');
    animElements.forEach((el: any, index: number) => {
      setTimeout(() => {
        el.classList.add('is-in-view');
      }, index * 50);
    });
  }
}
